<template>
    <div class="cz2__ai-modal__selfie-review">
        <div class="cz2__modal-popup__copy-wrapper">
            <div class="cz2__modal-popup__header">
                {{ $t('AI_REVIEW_HEADING') }}
            </div>

            <div class="cz2__modal-popup__copy">
                {{ $t('AI_REVIEW_COPY') }}
            </div>
        </div>

        <div
            :style="{
                'background-image': `url('${aiPreview?.sourceImage}')`,
            }"
            :class="[
                aiPreview?.orientation,
            ]"
            class="cz2__ai-modal__selfie-example"
        />

        <div class="cz2__ai-modal__selfie-review__buttons">
            <btn
                primary
                @click="confirmUpload"
            >
                <div class="cz2__btn-content-wrapper">
                    {{ $t('AI_REVIEW_CTA') }}
                    <img
                        src="../../assets/icons/chevron.svg"
                        width="auto"
                        height="12"
                    >
                </div>
            </btn>

            <upload-button
                :is-review="true"
            />
        </div>

        <base-disclaimer
            :message-copy="$t('AI_DISCLAIMER')"
        />
    </div>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz2__ai-modal {
            .cz2__ai-modal__selfie-review {
                width: 100%;
                height: 100%;
                overflow-y: auto;
                overflow-x: hidden;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                gap: 24px;
                text-align: center;

                .cz2__modal-popup__header {
                    margin-bottom: 8px;
                }

                .cz2__ai-modal__selfie-example {
                    border-radius: 24px;
                    background-color: #F0F0F0;
                    background-repeat: no-repeat;
                    background-position: center;
                    background-size: cover;

                    &.landscape {
                        width: 100%;
                        height: auto;
                        aspect-ratio: 16/9;
                    }

                    &.portrait {
                        height: 100%;
                        width: auto;
                        aspect-ratio: 2/3;
                    }

                    &.square {
                        height: 100%;
                        max-height: 300px;
                        width: auto;
                        aspect-ratio: 1/1;
                    }
                }

                .cz2__ai-modal__selfie-review__buttons {
                    display: flex;
                    flex-direction: column;
                    gap: 8px;

                    .cz2__btn {
                        width: 100%;
                    }
                }

                @include respond-above(sm) {
                    .cz2__ai-modal__selfie-example {
                        &.square {
                            max-height: none;
                        }
                    }
                }

                @include respond-above(lg) {
                    @media screen and (orientation: landscape) {
                        .cz2__ai-modal__selfie-example {
                            &.landscape {
                                width: auto;
                                height: 100%;
                            }

                            &.portrait {
                                height: 100%;
                                width: auto;
                            }
                        }
                    }

                    .cz2__ai-modal__selfie-example {
                        &.square {
                            width: auto;
                            max-width: none;
                            height: 100%;
                        }
                    }

                    .cz2__ai-modal__selfie-review__buttons {
                        flex-direction: row;
                        gap: 16px;

                        .cz2__btn {
                            width: 225px;
                        }
                    }

                    .cz2__btn--primary {
                        order: 2;
                    }
                }

                @include respond-below(lg) {
                    .cz2__modal-popup__copy-wrapper {
                        order: 2;
                    }

                    .cz2__modal-popup__copy {
                        margin-bottom: 0;
                    }

                    .cz2__ai-modal__selfie-review__buttons {
                        order: 3;
                    }

                    .cz2__ai-modal__disclaimer {
                        order: 4;
                        margin-top: -8px;
                    }
                }
            }
        }
    }
</style>

<script>
    import Btn from '../ui/Btn.vue';
    import BaseDisclaimer from './BaseDisclaimer.vue';
    import UploadButton from './UploadButton.vue';

    export default {
        components: {
            Btn,
            BaseDisclaimer,
            UploadButton,
        },

        computed: {
            aiUploadStates() {
                return this.$store.state.aiUploadStates;
            },

            aiPreview() {
                return this.$store.state.customizer.aiPreview;
            },
        },

        methods: {
            confirmUpload() {
                this.$store.dispatch('setAiUploadActiveState', this.aiUploadStates.building);

                this.$store.dispatch('buildFromSelfie');
            },
        },
    };
</script>
